var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"value":_vm.value,"position":"bottom","safe-area-inset-bottom":""},on:{"click-overlay":_vm.close}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }